import { NoGeneralDetails, RefetchOnError } from '@energy-stacks/shared';
import { useChargingStationDetails } from '../useChargingStationDetails';
import { ConnectorGroupsV21 } from './ConnectorGroupsV21';

export const ChargingStationDetailsConnectorsTabV21 = () => {
  const { chargingStationDetails, isSuccess, isError, refetch } =
    useChargingStationDetails();

  return (
    <>
      {isError ? <RefetchOnError onRefetch={refetch} /> : null}
      {!chargingStationDetails && isSuccess ? (
        <NoGeneralDetails onRefetch={refetch} />
      ) : (
        <ConnectorGroupsV21 />
      )}
    </>
  );
};
